import { Theme } from '@material-ui/core';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default function componentWithStyles({ palette }: Theme) {
    const backgroundColor = palette.background.default;
    return {
        root: {
            backgroundColor,
            height: '100%',
        },
        box: {
            padding: '4px 2px 0 2px',
            position: 'relative' as const,
            overflow: 'hidden',
            height: 'inherit',
        },
    };
}